import React, { useEffect} from 'react';
import {MenuItem, TextField} from '@mui/material'
import PropTypes from 'prop-types'
import { Autocomplete, Grid } from '@mui/material';
import { fonts } from '../../util/Theme';
import FormattedTextField from '../Formatted/FormattedTextField';
/**
 * component used to search through timesheets for admins
 * @component
 * @category Timesheets
 * @subcategory Submitted Timesheets 
 */
function AdminSearchBar(props) {
//nearly everything passed as a prop used to be some const defined here
//moved for pagination+filtering, also for clear button functionality

    useEffect(()=>{
            const searchObj = {
                resources: (props.resources.length > 0 ? props.resources.map(r => r.id) : undefined),
                resourceString: props.resourceString.toLowerCase(),
                projects: (props.projects.length > 0 ? props.projects.map(p => p.id) : undefined),
                projectString: props.projectString.toLowerCase(),
                clients: (props.clients.length > 0 ? props.clients.map(c => c.id): undefined),
                clientString: props.clientString.toLowerCase(),
                status: (props.status.length > 0 ? props.status: undefined),
                invoice_number: props.invoiceNumber,
                payment: (props.payment.length > 0 ? props.payment: undefined),
                invoiced: props.invoice
            }
            props.setSearchObj(searchObj);
            console.log(searchObj);
    },[props.resources,props.projects,props.clients,props.status,props.invoiceNumber,props.payment,props.resourceString,props.projectString,props.clientString, props.invoice]);

    return (
        <>
        
        {props.listOfProj ?
        <Grid item xs={2}>
        <Autocomplete
        disablePortal
        multiple
        options={props.listOfProj}
        value={props.projects}
        size='medium'
        multiline='true'
        isOptionEqualToValue={(option,value)=> option.id === value.id}
        getOptionLabel={(option)=>`${option.project_name}`}
        renderInput={(params) => <FormattedTextField {...params} InputLabelProps={{ style: { fontSize: fonts.labelSize } }} label="Projects" helperText="Type comma-separated entries or click on list"/>}
        inputValue={props.projectString}
        onInputChange={(event,value,reason)=>{
            if(reason !== 'reset') props.setProjectString(value);
        }}
        onChange={(event, value) => {
            props.setProjects(value);
            props.setProjectString("");
        }}
/> 
        </Grid>: <></>}
        
        
        {props.listOfResources ? 
        <Grid item xs={2}>
            <Autocomplete
            disablePortal
            multiple
            options={props.listOfResources}
            value={props.resources}
            size='medium'
            multiline='true'
            isOptionEqualToValue={(option,value)=> option.id === value.id}
            getOptionLabel={(option)=>`${option.first_name} ${option.last_name}`}
            renderInput={(params) => <FormattedTextField {...params} InputLabelProps={{ style: { fontSize: fonts.labelSize } }} label="Resources" helperText="Type comma-separated entries or click on list"/>}
            inputValue={props.resourceString}
            renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {`${option.first_name} ${option.last_name}`}
                  </li>
                );
              }}
            onInputChange={(event,value,reason)=>{
                if(reason !== 'reset') props.setResourceString(value)
            }}
            onChange={(event, value) => {
              event.preventDefault()
              props.setResourceString("")
              props.setResources(value);
            }}/>
        </Grid>
        : <></>}

        {props.listOfClients ?
            <Grid item xs={2}>
                <Autocomplete
            disablePortal
            multiple
            options={props.listOfClients}
            value={props.clients}
            size='medium'
            multiline='true'
            isOptionEqualToValue={(option,value)=> option.id === value.id}
            getOptionLabel={(option)=>`${option.short_name}`}
            renderInput={(params) => <FormattedTextField {...params} InputLabelProps={{ style: { fontSize: fonts.labelSize } }} label="Clients" helperText="Type comma-separated entries or click on list"/>}
            inputValue={props.clientString}
            onInputChange={(event,value,reason)=>{
                if(reason !== 'reset') props.setClientString(value)
            }}
            onChange={(event, value) => {
              //onUpdate(value.map(props.project => props.project.id));
              event.preventDefault()
              props.setClientString("")
              props.setClients(value);
            }}/>
            </Grid> : <></>
        }
        {props.statusEnabled ?
            <Grid item xs={2}>
                <Autocomplete
                disablePortal
                multiple
                options={['Submitted', 'Pending']}
                value={props.status}
                size='medium'
                multiline='true'
                isOptionEqualToValue={(option,value)=> option === value}
                getOptionLabel={(option)=>`${option}`}
                renderInput={(params) => <FormattedTextField {...params} InputLabelProps={{ style: { fontSize: fonts.labelSize } }} label="Status" />}
                onChange={(event, value) => {
                event.preventDefault()
                props.setStatus(value);
            }}/>
            </Grid>
            : <></>
        }
        {props.invoiceEnabled? 
            <Grid item xs={2}>
                <TextField
                select
                value={props.invoice}
                onChange={(e) => {e.preventDefault(); props.setInvoice(e.target.value)}}
                label='Invoiced'
                fullWidth>
                    <MenuItem value={'Invoiced'}>Invoiced</MenuItem>
                    <MenuItem value={'Not Invoiced'}>Not Invoiced</MenuItem>
                    <MenuItem value={'Both'}>Both</MenuItem>
                </TextField>
            </Grid>:<></>
        }
        {props.invoiceEnabled ? 
        <Grid item xs={2}>
            <FormattedTextField 
            label='Invoice Number'
            value={props.invoiceNumber}
            onChange={(e)=>{
                e.preventDefault();
                let value = e.target.value
                try{
                    if(Number(value) >= 0){
                        props.setInvoiceNumber(value)
                    }
                }catch{}
            }}/>
        </Grid> : <></>}
        {props.paymentEnabled? 
            <Grid item xs={2}>
                <Autocomplete
                disablePortal
                multiple
                options={[true, false]}
                value={props.payment}
                size='medium'
                multiline='true'
                isOptionEqualToValue={(option,value)=> option === value}
                getOptionLabel={(option)=>`${option}`}
                renderInput={(params) => <FormattedTextField {...params} InputLabelProps={{ style: { fontSize: fonts.labelSize } }} label="Payment Made" />}
                onChange={(event, value) => {
                    event.preventDefault()
                    props.setPayment(value);
            }}/>
            </Grid>:<></>
        }

        
        </>
    );
}

AdminSearchBar.propTypes = {
    /**
     * list of projects to choose from, each object following the db schema for a project
     */
    listOfProj: PropTypes.arrayOf(PropTypes.object),
    /**
     * list of resources to choose from, each object following the db schema for a resource
     */
    listOfResources: PropTypes.arrayOf(PropTypes.object),
    /**
     * list of clients to choose from, each object following the db schema for a client
     */
    listOfClients: PropTypes.arrayOf(PropTypes.object),
    /**
     * whether or not searching by status of timesheet is enabled
     */
    statusEnabled: PropTypes.bool,
    /**
     * whether or not searching by invoice status is enabled 
     */
    invoiceEnabled: PropTypes.bool,
    /**
     * whether or not searching by payment status in enabled
     */
    paymentEnabled: PropTypes.bool,
    /**
     * function called as search critera are changed, returns an object with the requirements of each critera
     */
}

AdminSearchBar.defaultProps = {
    statusEnabled: false,
    invoiceEnabled:false
}


export default AdminSearchBar;